import React from 'react'
import {connect} from 'react-redux'
import classNames from 'classnames'
import {number, shape, string} from 'prop-types'
import {ReactComponent as Valid} from './icons/valid.svg'
import {ReactComponent as Invalid} from './icons/invalid.svg'
import {isPasswordRequirementInvalid, requirementsNames} from '../passwordRequirements.helper'

const RequirementItem = ({passwordPolicy, password, policyName}) => {
  const invalid = isPasswordRequirementInvalid({password, [policyName]: passwordPolicy[policyName]})
  return (
    <div
      className={classNames('requirementItem', {invalid})}
    >
      {invalid
        ? (<Invalid />)
        : (<Valid />)
      }
      <span>{requirementsNames[policyName](passwordPolicy[policyName])}</span>
    </div>
  )
}

const mapStateToProps = ({loginReducer}) => ({
  passwordPolicy: loginReducer.passwordPolicy,
  password: loginReducer.password
})

RequirementItem.propTypes = {
  password: string,
  passwordPolicy: shape({
    minLength: number,
    minLowercase: number,
    minUpperCase: number,
    minNumbers: number,
    minSpecial: number
  }),
  policyName: string
}

export default connect(mapStateToProps)(RequirementItem)
